'use client';

import { WishlistDialog as SharedWishlistDialog } from '@veranda/shared/wishlist/client';
import type { ReactNode } from 'react';
import { buttonVariants } from './ui/button';
import { WishlistCard } from './wishlist-card';

function WishlistDialogRoot({ children }: { children: ReactNode }) {
  return <SharedWishlistDialog>{children}</SharedWishlistDialog>;
}

function WishlistTrigger({ children }: { children: ReactNode }) {
  return (
    <SharedWishlistDialog.Trigger>{children}</SharedWishlistDialog.Trigger>
  );
}

function WishlistContent() {
  return (
    <SharedWishlistDialog.Content
      wishlistCard={WishlistCard}
      className="[--color:var(--color-brand-burgundy)]"
      primaryButtonClassName={buttonVariants({ variant: 'primary' })}
      secondaryButtonClassName={buttonVariants({ variant: 'secondary' })}
    />
  );
}

WishlistDialogRoot.Trigger = WishlistTrigger;
WishlistDialogRoot.Content = WishlistContent;

export const WishlistDialog = WishlistDialogRoot;
